import React, {Component} from 'react';
import {Button} from "react-bootstrap";
import {LinkContainer, IndexLinkContainer} from "react-router-bootstrap";
export default class BlogListPagination extends Component {
  renderPreviousButton() {
    if (this.props.page > 0) {
      if (this.props.page === 1) {
        return (
          <div className="pull-left" style={{marginTop:10}}>
            <IndexLinkContainer
              active={false}
              to={`${this.props.category ? `/blog/${this.props.category}`
                : this.props.tag ? `/blog/tag/${this.props.tag}` 
                  : `/blog`}`}
            >
              <Button>
                <i className="fa fa-arrow-left fa-fw" aria-hidden="true"/> Previous
              </Button>
            </IndexLinkContainer>
          </div>
        );
      } else {
        return (
          <div className="pull-left" style={{marginTop:10}}>
            <LinkContainer to={`${this.props.category ? `/blog/${this.props.category}/page/${this.props.page-1}` 
              : this.props.tag ? `/blog/tag/${this.props.tag}/page/${this.props.page-1}`
                : `/blog/page/${this.props.page-1}`}`}
            >
              <Button>
                <i className="fa fa-arrow-left fa-fw" aria-hidden="true"/> Previous
              </Button>
            </LinkContainer>
          </div>
        );
      }
    }
    return true;
  }
  renderNextButton() {
    if (this.props.lastEvaluatedKey) {
      return (
        <div className="pull-right" style={{marginTop:10}}>
          <LinkContainer to={`${this.props.category ? `/blog/${this.props.category}/page/${this.props.page+1}`
            : this.props.tag ? `/blog/tag/${this.props.tag}/page/${this.props.page+1}` 
              : `/blog/page/${this.props.page+1}`}`}
          >
            <Button>
              Next <i className="fa fa-arrow-right fa-fw" aria-hidden="true"/>
            </Button>
          </LinkContainer>
        </div>
      );
    }
    return true;
  }
  renderPagination() {
    return (
      <div key={1}>
        {this.renderPreviousButton()}
        {this.renderNextButton()}
      </div>
    );
  }
  render() {return this.renderPagination()}
}


// WEBPACK FOOTER //
// ./src/components/Blog/BlogListPagination.js